import { useQuery } from "@tanstack/react-query";
import { fetchRapidFireQuestions } from "../services/rapidFireService";

export function useRapidFireQuestions(params = {}, options = {}) {
  return useQuery({
    queryKey: ["rapidFireQuestions", params],
    queryFn: async () => {
      const response = await fetchRapidFireQuestions(params);
      return response.payload;
    },
    ...options,
  });
}
